import React, { Component } from "react";

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      templateId: this.props.templateId
    };
  }

  renderSocial = () => {
    switch (this.state.templateId) {
      case "1":
        return (
          <div className="socialIcons">
            <a
              href="https://goo.gl/zoKp4Z"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-google fa-2x"></i>
            </a>
            <a
              href="https://www.yelp.com/biz/bowinkles-restaurant-rio-linda"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-yelp fa-2x"></i>
            </a>
            <a
              href="https://www.facebook.com/pages/Bowinkles/152251514818823"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-facebook-f fa-2x"></i>
            </a>
          </div>
        );
        break;
      case "2":
        return (
          <div className="socialIcons">
            <a
              href="https://goo.gl/zoKp4Z"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-google fa-2x"></i>
            </a>
            <a
              href="https://www.yelp.com/biz/bowinkle-drive-thru-rancho-cordova"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-yelp fa-2x"></i>
            </a>
            <a
              href="https://www.facebook.com/Bowinkle-Drive-Thru-Rancho-112045923495549/?rf=258331081514609"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-facebook-f fa-2x"></i>
            </a>
          </div>
        );
        break;
      default:
        return null;
    }
  };

  render() {
    var today = new Date();
    return (
      <div className="footerContainer">
        <footer className="text-center">
          {this.renderSocial()}

          <p>
            &copy; {today.getFullYear()} Bowinkles Drive Thru. All Rights
            Reserved.
          </p>
        </footer>
      </div>
    );
  }
}

export default Footer;
